import React from 'react';
import { JotType } from 'consts';
import PropTypes from 'prop-types';
import { actions } from 'actions';
import { connect } from 'unistore/preact';
import { isNullOrUndefOrEmpty, recommendationUtils, toObject } from 'utils';

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/recommend/RecommendItem.scss';

const RecommendItem = ({
  content, recommendType, headingLevel = 4,
  isImgCols = false, isImgList = false,
  jot
}) => {
  if (isNullOrUndefOrEmpty(content) || isNullOrUndefOrEmpty(recommendType)) {
    return null;
  }

  const { title, linkUrl, imgUrl, confidence } = toObject(content);
  const hasImgUrl = !isNullOrUndefOrEmpty(imgUrl);
  const showImg = hasImgUrl && (isImgCols || isImgList);
  const imgStyles = {
    backgroundImage: showImg ? `url('${encodeURI(imgUrl)}')` : null
  };

  const onItemLinkClick = () => {
    recommendationUtils.setRecommendedLinkStorage(linkUrl);

    jot({
      space: 'poll',
      type: JotType.ContentRecommendationClick,
      data: { contentRecUrl: linkUrl, contentRecConfidence: confidence }
    });
  };

  return (
    <div className={`csw-recommend-item ${recommendType}`}>
      {showImg &&
        <a className="csw-recommend-item-img"
           href={linkUrl}
           style={imgStyles}
           target="_blank"
           rel="noopener noreferrer"
           onClick={onItemLinkClick}
           role="img"
           title={title}
           aria-label={title} />}
      <div className="csw-recommend-item-detail">
        <div className="csw-recommend-item-heading"
             role="heading"
             aria-level={headingLevel}>
          <a href={linkUrl}
             className="outline"
             onClick={onItemLinkClick}
             target="_blank"
             rel="noopener noreferrer">
            {title}
          </a>
        </div>
      </div>
    </div>
  );
};

RecommendItem.propTypes /* remove-proptypes */ = {
  content: PropTypes.object.isRequired,
  recommendType: PropTypes.string.isRequired,
  headingLevel: PropTypes.number,
  isImgCols: PropTypes.bool,
  isImgList: PropTypes.bool,
  jot: PropTypes.func.isRequired,
};

export default connect('', actions)(RecommendItem);
